export function resizeImage(url, width = 500, height = 500) {
    if (url?.startsWith('http')) {
        return `${url}?height=${height}&width=${width}`
    }
    return url;
}
